import { Search } from 'lucide-react';

import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { ControllerAutoZoomSupport } from './types';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type ZoomInFeatureParams = FeatureHoookParams;
export const useAutoZoomFeature = (_params: ZoomInFeatureParams = {}): Feature<boolean> => {
	// const dispatch = useAppDispatch();
	const [controller] = useDesign<Controller, ControllerAutoZoomSupport>();

	useSubscription(controller, false, [['viewport-config', 'updated']]);

	const controllerSupportsAutozoomFeature = (controller?.viewport?.config.autoZoom ?? null) !== null;
	const autoZoom = controller?.viewport?.config?.autoZoom ?? false;

	const [enabled, tooltip] = (() => {
		if (!controllerSupportsAutozoomFeature) return [false, lang.zoom.tooltip.disabledNotSupportCurrentView];
		return [true, lang.zoom.tooltip.autozoom];
	})();

	return {
		name: 'autoZoom',
		label: lang.zoom.label.autozoom,
		icon: (props = {}) => <Search color={controllerSupportsAutozoomFeature && autoZoom ? 'green' : 'black'} {...props} />,
		tooltip,
		disabled: !enabled,
		value: controllerSupportsAutozoomFeature ? autoZoom : false,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.viewport.updateConfig({ autoZoom: !autoZoom });
				if (!autoZoom) controller.viewport.actions.triggerAutoZoom();
			}
			// dispatch(setAutoZoom(!autoZoomState));
		}
	};
};
